/* eslint-disable no-unreachable */
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import CourseContentLeft from './CourseContentLeft';
import Main from '../../../components/layout/Main';
import CourseOverview from './CourseOverview';
import { getCourse } from '../../../redux/actions/elearningActions';
import Loader from '../../../components/core/Loader';

function Course() {
  const { courseId } = useParams();
  const dispatch = useDispatch();
  const course = useSelector((state) => state.elearning.selectedCourse);

  useEffect(() => {
    dispatch(getCourse(courseId));
  }, []);

  if (!course) {
    return <Loader />;
  }

  return (
    <div className="grid grid-cols-12 min-h-screen bg-grey-super_light">
      {/* Left Content */}
      <div className="hidden lg:block lg:col-span-2">
        <CourseContentLeft />
      </div>

      {/* Main Content */}
      <div className="col-span-12 lg:col-span-8">
        <CourseOverview course={course} />
      </div>

      {/* Right Content */}
      <div className="col-span-2" />
    </div>
  );
}

Course.propTypes = {};

export default Course;
